import React, { useEffect } from 'react';

import { Helmet } from 'react-helmet';

import { GlobalSettingsProvider } from 'context/GlobalSettingsContext';
import { ContentstackProvider } from 'context/contentstack';
import { LocaleProvider } from 'context/locale';

import { useVisitorStatus } from 'hooks/useVisitorStatus';

import AnalyticsService from 'services/analyticsService';
import { PAGE_INCLUDES, buildIncludeQuery } from 'services/personalize/includes';

import { isPersonalizeEnabled } from 'utils/featureFlags';

const PAGE_INCLUDES_QUERY = isPersonalizeEnabled ? buildIncludeQuery(PAGE_INCLUDES) : null;

const Analytics = ({ pathname, pageContext }) => {
  useEffect(() => {
    AnalyticsService.trackPageDataLoaded({
      pageType: pageContext?.page_components?.page_type,
      campaignPageType: pageContext?.page_components?.campaign_type,
    });
  }, [pathname]);

  return null;
};

const VisitorStatusHandler = () => {
  useVisitorStatus();
  return null;
};

export const wrapPageElement = ({ element, props }) => {
  const { localisation, availableLocalisations, page_components, ab_test_configuration, globalSettings } =
    props.pageContext;

  return (
    <LocaleProvider localisation={localisation} availableLocalisations={availableLocalisations}>
      <Helmet>
        <script>
          {`window.__pageUid = ${JSON.stringify(props.pageContext.uid || null)};
          ${PAGE_INCLUDES_QUERY ? `window.__pageIncludes = ${JSON.stringify(PAGE_INCLUDES_QUERY)};` : ''}`}
        </script>
      </Helmet>
      <VisitorStatusHandler />
      <ContentstackProvider
        key={page_components?.uid} // Recreate provider on every page change
        pageData={page_components}
        personalizeVariantMeta={props.pageContext.personalizeVariantMeta}
        abTestConfiguration={ab_test_configuration}
      >
        <GlobalSettingsProvider settings={globalSettings}>
          <Analytics pathname={props.location.pathname} pageContext={props.pageContext} />
          {element}
        </GlobalSettingsProvider>
      </ContentstackProvider>
    </LocaleProvider>
  );
};
